import { handleActions } from 'redux-actions';
import { FlowNodeTypes } from '../../powerFlowShared/components/types';
import { getRequestID } from '../../shared/util/request';
import { emailFlowActions } from '../actions/emailFlowActions';
const { emailFlowGet, emailFlowGetSucceeded, emailFlowGetFailed, emailFlowAdd, emailFlowAddSucceeded, emailFlowAddFailed, emailFlowEdit, emailFlowEditSucceeded, emailFlowEditFailed, emailFlowAddNode, emailFlowResetState, } = emailFlowActions;
function emptyNode() {
    return {
        badges: [],
        childIds: [],
        connectionLabel: 'arrow',
        icon: '',
        id: getRequestID(),
        isAction: true,
        isEditable: false,
        isRemovable: false,
        nodeType: FlowNodeTypes.ACTION,
        overlay: [],
        pageX: 100,
        pageY: 100,
        parentId: null,
        payload: null,
        text: '',
    };
}
const initialState = {
    id: null,
    meta: {
        asyncStatus: 'succeeded',
        hasUnSavedChanges: false,
    },
    email_address: null,
    current_flow: null,
    current_payload: null,
    name: null,
    nodes: [],
    queuesState: {
        queues: [],
        asyncStatus: 'succeeded',
    },
};
// Reducer
const emailFlow = handleActions({
    [emailFlowAddNode.toString()]: (state, action) => {
        var _a;
        const { node } = action.payload;
        if (!node) {
            return state;
        }
        const newEmptyNode = emptyNode();
        const newNode = Object.assign({}, newEmptyNode, node);
        return Object.assign(Object.assign({}, state), { nodes: [...((_a = state.nodes) !== null && _a !== void 0 ? _a : []), newNode] });
    },
    [emailFlowGet.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'loading' }), email_address: action.payload.email_address });
    },
    [emailFlowGetSucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { id: action.payload.data.id, meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded' }), email_address: action.payload.data.location, name: action.payload.data.name, isActive: action.payload.data.active, nodes: action.payload.data.actions });
    },
    [emailFlowGetFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
    },
    [emailFlowAdd.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'loading' }) });
    },
    [emailFlowAddSucceeded.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded' }) });
    },
    [emailFlowAddFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
    },
    [emailFlowEdit.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'loading' }) });
    },
    [emailFlowEditSucceeded.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded' }) });
    },
    [emailFlowEditFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
    },
    [emailFlowResetState.toString()]: () => initialState,
}, initialState);
export default emailFlow;
